import { render, staticRenderFns } from "./HorizontalList.vue?vue&type=template&id=21bc201c&scoped=true"
import script from "./HorizontalList.vue?vue&type=script&lang=js"
export * from "./HorizontalList.vue?vue&type=script&lang=js"
import style0 from "./HorizontalList.vue?vue&type=style&index=0&id=21bc201c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21bc201c",
  null
  
)

export default component.exports